import { useDocumentTitle } from "../../hooks/use-document-title";
import "./Error404Page.scss";

export default function Error404Page() {
  useDocumentTitle("404 Not Found");

  return (
    <div className="error-404-page-container">
      <div>404. Page Not Found.</div>
    </div>
  );
}
